import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from "../../../../../environments/environment";

@Component({
  selector: 'app-college-info-create',
  templateUrl: "./college-info-create.component.html",
  styleUrls: ["./college-info-create.component.scss"],
})
export class CollegeInfoCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  form!: FormGroup;
  saving = false;
  submitted = false;

  // display lists (frontend)
  businessTypes = ['College', 'Institute', 'University'];
  collegeTypes = ['Private', 'Government'];
  universities: any[] = []; // store full objects { _id, name, ... }

  constructor(private fb: FormBuilder, private http: HttpClient) { }

  ngOnInit(): void {
    // NOTE: form control names are **exact backend keys**
    this.form = this.fb.group({
      collegename: ['', Validators.required],
      businesstype: ['', Validators.required],
      university: ['', Validators.required],
      universityurl: [''],
      description: ['']
    });

    // Load universities (keep full objects so <option [value]="u._id"> works)
    this.http.get<any>(`${environment.apiUrl}/university`)
      .subscribe({
        next: res => {
          if (res && res.results && Array.isArray(res.results)) {
            this.universities = res.results;
          } else {
            console.warn('Unexpected university response:', res);
            this.universities = [];
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Failed to load universities:', err);
          this.universities = [];
        }
      });
  }

  // convenience getter for template
  get f() { return this.form.controls; }

  submit() {
    this.submitted = true;

    if (this.saving) return; // prevent double submit

    // mark to show validation errors
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      console.warn('Form invalid, aborting submit', this.form.errors);
      return;
    }

    this.saving = true;

    // Because control names match backend, we can send the form value directly
    const payload: any = {
      ...this.form.value,
      userid: localStorage.getItem('userId') || ''
    };

    if (!payload.userid) {
      alert('User not logged in (userid missing).');
      this.saving = false;
      return;
    }

    console.log('Posting payload to /college:', payload);

    this.http.post<any>(`${environment.apiUrl}/college`, payload)
      .subscribe({
        next: res => {
          console.log('Saved:', res);
          alert('Saved successfully');
          this.form.reset();
          this.submitted = false;
          this.saving = false;
        },
        error: (err: HttpErrorResponse) => {
          console.error('Save failed', err);
          if (err && err.error && err.error.message) {
            alert('Save failed: ' + err.error.message);
          } else if (err && err.status) {
            alert('Save failed. HTTP status: ' + err.status);
          } else {
            alert('Save failed. Check console for details.');
          }
          this.saving = false;
        }
      });
  }
}
